var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "21px",
    viewBox: "0 0 15 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-44.000000, -567.000000)",
    fill: "rgba(0, 0, 255, 0.8)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-copy-7",
    transform: "translate(44.000000, 567.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.46428571,1.49285714 C9.5254913,1.49285714 11.1964286,3.16379442 11.1964286,5.225 C11.1964286,7.28620558 9.5254913,8.95714286 7.46428571,8.95714286 C5.40308013,8.95714286 3.73214286,7.28620558 3.73214286,5.225 C3.73214286,3.16379442 5.40308013,1.49285714 7.46428571,1.49285714 M7.46428571,6.62961749e-16 C4.5785979,6.62961749e-16 2.23928571,2.33931218 2.23928571,5.225 C2.23928571,8.11068782 4.5785979,10.45 7.46428571,10.45 C10.3499735,10.45 12.6892857,8.11068782 12.6892857,5.225 C12.6892857,3.83924384 12.1387962,2.51024465 11.1589186,1.53036707 C10.1790411,0.550489491 8.85004187,6.62961749e-16 7.46428571,6.62961749e-16 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9285714,20.9 L13.4357143,20.9 L13.4357143,17.1678571 C13.4357143,16.1780313 13.0425075,15.2287462 12.342595,14.5288336 C11.6426824,13.8289211 10.6933973,13.4357143 9.70357143,13.4357143 L5.225,13.4357143 C3.16379442,13.4357143 1.49285714,15.1066516 1.49285714,17.1678571 L1.49285714,20.9 L0,20.9 L0,17.1678571 C0,14.2821693 2.33931218,11.9428571 5.225,11.9428571 L9.70357143,11.9428571 C12.5892592,11.9428571 14.9285714,14.2821693 14.9285714,17.1678571 L14.9285714,20.9 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileHover);
export default __webpack_public_path__ + "static/media/profile-hover.95f4ae92dcce56592147f51d28c2be1d.svg";
export { ForwardRef as ReactComponent };